import { useDraggable } from '@dnd-kit/core'
import { nanoid } from 'nanoid'
import { useRef } from 'react'
import SidebarField from '../Field/SidebarField'

import styles from './DraggableSidebarField.module.css'

function DraggableSidebarField(props) {
  const { field, ...rest } = props

  const id = useRef(nanoid())

  const { attributes, listeners, setNodeRef } = useDraggable({
    id: id.current,
    data: {
      field,
      fromSidebar: true,
    },
  })

  return (
    <div
      ref={setNodeRef}
      className={styles.container}
      {...listeners}
      {...attributes}
    >
      <SidebarField field={field} {...rest} />
    </div>
  )
}
export default DraggableSidebarField
